import React from "react";
import { Fingerprint, Check } from "lucide-react";

export default function IdentityStep({ options, selected, onChange, title = "Step 4 — Identity Resolution Rules", description = "Select the matching rules that should merge records into one Unified Individual, without creating false merges." }) {
  const toggle = (id) => {
    onChange(selected.includes(id) ? selected.filter((s) => s !== id) : [...selected, id]);
  };
  return (
    <div>
      <h3 className="font-heading font-semibold text-white mb-1">{title}</h3>
      <p className="text-sm text-slate-400 mb-4">{description}</p>
      <div className="space-y-2">
        {options.map((o) => {
          const active = selected.includes(o.id);
          return (
            <button
              key={o.id} onClick={() => toggle(o.id)} data-testid={`identity-rule-${o.id}`}
              className={`w-full flex items-center gap-3 p-3.5 rounded-lg border text-left transition-colors ${
                active ? "border-indigo-400 bg-indigo-400/10" : "border-white/10 bg-white/[0.02] hover:border-white/25"
              }`}
            >
              <div className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 ${active ? "bg-indigo-400/20 text-indigo-300" : "bg-white/5 text-slate-400"}`}>
                <Fingerprint className="w-3.5 h-3.5" />
              </div>
              <span className="text-sm text-slate-200 flex-1">{o.label}</span>
              {active && <Check className="w-4 h-4 text-indigo-400" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
